export class Company {
    id: number;
    company_name: string;
    tax_id: string;
    first_name: string;
    last_name: string;
    properties: any;
  }
  